import { render, staticRenderFns } from "./SupplierTagsNew.vue?vue&type=template&id=562447ad&scoped=true&"
import script from "./SupplierTagsNew.vue?vue&type=script&lang=js&"
export * from "./SupplierTagsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562447ad",
  null
  
)

export default component.exports